import { css } from '@emotion/react';

import colors from '../../../../configs/colors';

export const cardStyles = css`
  width: 425px;
  height: auto;
  padding: 0;
`;

export const cardHeaderStyles = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 40px;
  border-bottom: 1px solid ${colors.GREY};
`;

export const titleStyles = css`
  font-weight: 600;
  font-size: 18px;
`;

export const closeButtonStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: unset;
  background-color: ${colors.TRANSPARENT};
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    opacity: 0.7;
  }
`;

export const closeIconStyles = css`
  font-size: 24px;
  color: ${colors.PRIMARY_BLUE};
`;

export const cardBodyStyles = css`
  padding: 24px 40px;
`;

export const descriptionStyles = css`
  text-align: center;
  font-size: 16px;
`;

export const buttonStyles = css`
  margin: 32px 0 0 0;
`;
